import { Studio, StudioConfigType } from 'Core/Studio'
import { ContainerType, TaskConfigType, UseCaseTypes } from 'Types/Tasks.types'
import { TaskRegistry } from './TaskRegistry'

export interface ITask<TConfig = unknown> {
    initialize(config: TConfig): void
    shouldEnableViolations(): boolean
    destroy(): void
}

export interface ITaskConstructor {
    new (studio: Studio): ITask
}

export class TaskAdapter {
    constructor(private studio: Studio) {}

    public adapt(
        studioConfig: StudioConfigType
    ): ITask<TaskConfigType<ContainerType, unknown>> | undefined {
        const taskParams: {
            type: UseCaseTypes
            taskKey?: string
        } = {
            type: studioConfig.taskType,
        }
        if (studioConfig.interfaceKey) {
            taskParams.taskKey = studioConfig.interfaceKey
        }
        const task = TaskRegistry.getInstance().getTask(taskParams)
        if (!task) {
            console.error('Unsupported Task Type', studioConfig.taskType)
            this.studio.exitTask({
                type: 'error',
                message: `No task interface found for interface key ${studioConfig.interfaceKey}`,
            })
            return
        }
        return new task(this.studio)
    }
}
